export default {
  tabs: {
    access: 'Access',
    notification_preferences: 'Notification preferences',
  },
  sections: {
    notification_preferences: {
      title: 'Notification preferences',
      form: {
        has_voice_call_reminders: {
          label: 'Receive automated calls about pending orders',
        },
        voice_reminders_phone_number: {
          label: 'Phone number to receive calls',
        },
        has_whatsapp_notifications: {
          label: 'Send notifications (e.g. orders paused) via WhatsApp',
        },
        whatsapp_phone_number: {
          label: 'WhatsApp phone number',
        },
        has_order_email_notifications: {
          label: 'Send order notifications via email',
        },
        order_notifications_email: {
          label: 'Email address to forward order notifications',
        },
      },
    },
    voice_calls: {
      title: 'Voice calls',
    },
    whats_app_notifications: {
      title: 'WhatsApp notifications',
    },
    order_email_notifications: {
      title: 'Order email notifications',
    },
    access_control: {
      title: 'Access control',
      form: {
        company_ids: {
          label: 'Can access restaurants',
          tooltip: 'Provides access to following restaurants (additionally to restaurants in the same brand)',
        },
      },
    },
  },
  buttons: {
    save: 'Save',
  },
  toasts: {
    failed_to_save_changes: 'Failed to save changes',
    changes_got_saved: 'Changes got saved',
  },
};
